module.exports = __webpack_public_path__ + "img/Retail13.3e001d1b.png";